import { getClient } from '@api/client';
import { graphql } from '@api/generated';

export const getVaEscalationSummaryQuery = graphql(`
  query getVaEscalationSummary($conversationSid: ID!) {
    escalationSummaryByConversationSid(conversationSid: $conversationSid)
  }
`);

/**
 * Queries for the VA escalation summary by conversationSid.
 *
 * Keyed by conversationSid so it can be resolved at call-offer time, before the CSR accepts
 * (kazooCallId is not available pre-accept). Returns null when no summary has been persisted.
 *
 * Errors should be handled by the caller.
 * @param conversationSid
 * @returns the escalation summary text, or null when there is none
 */
async function getVaEscalationSummary(
  conversationSid: string,
): Promise<string | null> {
  const { data, error } = await getClient().query({
    query: getVaEscalationSummaryQuery,
    variables: { conversationSid },
  });

  if (error) {
    throw new Error(error.message);
  }

  return data?.escalationSummaryByConversationSid ?? null;
}

export default getVaEscalationSummary;
